import React from "react";
import "./planos.css";
import { FaRocket, FaCheckCircle, FaChartLine, FaUserFriends, FaCogs, FaHeadset } from "react-icons/fa";

const vantagens = [
    { icon: <FaRocket />, text: "Impulsione seu negócio rapidamente" },
    { icon: <FaCheckCircle />, text: "Layout totalmente personalizado" },
    { icon: <FaChartLine />, text: "Aumente suas vendas sem precisar de site" },
    { icon: <FaUserFriends />, text: "Melhore sua presença online" },
    { icon: <FaCogs />, text: "Sistema atualizado constantemente" },
    { icon: <FaHeadset />, text: "Suporte especializado sempre que precisar" },
];

const Planos: React.FC = () => {
    return (
        <section id="planos">
            <div className="planos-card pb-5">
                <div className="container planos-container pt-4">

                    {/* 🔹 Texto (Esquerda) */}
                    <div className="planos-texto">
                        <h1>Promova seus produtos rapidamente. <br />
                            Sem precisar de um site. <br />
                            <strong>Por apenas R$140,00/ano.</strong>
                        </h1>
                        <a href="#contato" className="botao-desktop cta-button">Começar</a>
                    </div>

                    {/* 🔹 Vantagens (Direita) */}
                    <div className="planos-vantagens">
                        <h3>Vantagens para contratar</h3>
                        {vantagens.map((vantagem, index) => (
                            <div key={index} className="mb-4 mt-4">
                                <div className="vantagem-item">
                                    {vantagem.icon}
                                    <p className="mb-0">{vantagem.text}</p>
                                </div>
                                {index < vantagens.length - 1 && <hr />}
                            </div>
                        ))}
                    </div>

                    {/* 🔹 Botão (Movido para baixo em telas menores) */}
                    <div className="planos-botao botao-mobile">
                        <a href="https://wa.me/5517991822859?text=Olá, gostaria de criar o meu link." className="cta-button">Começar</a>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Planos;
